<script>
  export let height = '1';
  export let color = '#F3F9FC';
</script>

<div class="h-divider" style="border: {height}px solid {color};"></div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .h-divider {
    width: 100%;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.04) inset;
    opacity: 1;
  }
</style>
